import { OrderEventDTO } from "@/api/custom-schema";

export interface Order {
  id: string;
  daily_counter?: number | string | null;
  formatted_id?: string | null;
  status?: string | number | boolean | null;
  items: OrderItem[];
  created_at: string;
  sent_at: string;
}

export interface OrderItem {
  id: string;
  formatted_id?: string | null;
  name: string;
  description: string;
  image: string;
  quantity: number;
  price: number;
}

export function mapOrderEventDTOToOrder(orderEventDTO: OrderEventDTO): Order {
  return {
    ...orderEventDTO.data,
    id: orderEventDTO.data.id,
    daily_counter:
      orderEventDTO.data.daily_counter ?? orderEventDTO.daily_counter ?? null,
    formatted_id:
      orderEventDTO.data.formatted_id ?? orderEventDTO.formatted_id ?? null,
    status: orderEventDTO.data.status ?? orderEventDTO.status ?? null,
    items: orderEventDTO.data.items,
    created_at: orderEventDTO.data.created_at,
    sent_at: orderEventDTO.sent_at,
  };
}
